<template>
  <benefit-notification-box-base
    :icon-path="iconPath"
    :description="description"
    :title="title"
    :color="color"
    :variant="variant"
    @description-click="handleLinkClick"
  />
</template>

<script>
import BenefitNotificationBoxBase from '@/base-components/BenefitNotificationBoxBase.vue';
import Segment from '@/Segment';

export default {
  name: 'WebPaymentNotificationBox',
  components: {
    BenefitNotificationBoxBase,
  },
  computed: {
    iconPath() {
      return 'icons/green-light-bulb.svg';
    },
    description() {
      return 'איך לשלם פחות על המינוי שלי?';
    },
    title() {
      return 'אפשר לרכוש מינוי כבר עכשיו ולשלם עליו פחות!';
    },
    color() {
      return 'green';
    },
    variant() {
      return 'web-payment';
    },
  },
  methods: {
    handleLinkClick() {
      Segment.trackUserInteraction('AppleTrial_NoPromo_Price_clicked');
      this.$emit('link-click');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
